const cardData = [
  {
    img: "images/reactivities.png",
    tags: ["react", ".net core", "C#"],
    title: "Reactivities",
    description:
      "Social media site for planning activites, following friends, and chatting with people.",
    hasGitHubUrl: true,
    gitHubUrl: "https://github.com/jamespagedev/Reactivities",
    hasWebsiteUrl: true,
    websiteUrl: "https://jamespagedev-reactivities-project.fly.dev/",
  },
  {
    img: "images/s-j-architecture.jpg",
    tags: ["html", "css", "javascript"],
    title: "S&J Architecture",
    description:
      "Multi-page startup website complete with a marketing landing page, a services page, and a contact form.",
    hasGitHubUrl: true,
    gitHubUrl: "https://github.com/jamespagedev/User-Interface-Project-Week",
    hasWebsiteUrl: true,
    websiteUrl:
      "https://htmlpreview.github.io/?https://github.com/jamespagedev/User-Interface-Project-Week/blob/master/index.html",
  },
  {
    img: "images/ff7-level-calculator.jpg",
    tags: ["java", "swing"],
    title: "FF7 Leveling Calculator",
    description:
      "Calculator for Final Fantasy 7. The calculator will show you the next possible random stats you will gain upon your next level up.",
    hasGitHubUrl: true,
    gitHubUrl: "https://github.com/jamespagedev/FF7-LevelUpStatCalculator",
    hasWebsiteUrl: false,
    websiteUrl: "",
  },
  {
    img: "images/maze.jpg",
    tags: ["Python", "Graph", "CS"],
    title: "The Maze",
    description:
      "A Maze of 500 rooms where using bfs, queue, and stack to search every room with the least possible moves made.",
    hasGitHubUrl: true,
    gitHubUrl: "https://github.com/jamespagedev/Sprint-Challenge--Graphs",
    hasWebsiteUrl: false,
    websiteUrl: "",
  },
];

export { cardData };
